import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "px-6 pt-2"
}
const _hoisted_3 = { class: "border border-black rounded-xl p-3" }
const _hoisted_4 = { class: "flex justify-between mb-3" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "grid grid-cols-2 text-center" }
const _hoisted_8 = { class: "flex ml-2 justify-center" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = {
  key: 2,
  class: ""
}
const _hoisted_13 = {
  key: 3,
  class: ""
}
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "py-2.5" }, null, -1)
const _hoisted_17 = { class: "grid grid-cols-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 flex justify-center" }, "Total", -1)
const _hoisted_19 = { class: "flex justify-center" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "text-xs"
}

import { onMounted, ref, computed, watch } from 'vue';

    interface addedItemType {
        name: string,
        cold: boolean | undefined,
        price: number,
        qty: number,
        total:number,
        temp?: boolean,
        bigPrice? :boolean | undefined,
    }

    interface history{
        saveOrders:addedItemType,
        timestamp:string,
        table:string,total:number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PrintView',
  props: {
        index: String
    },
  setup(__props) {

const props = __props;



    const order = computed(()=>{
        if(!props.index){
            return null
        }
        return savedOrders.value[parseFloat(props.index)]/*  ?? savedOrders.value[props.index] */
    })
    let savedOrders = ref<history[]>([]) 
    const fetchHistory = () =>{
        let item = localStorage.getItem('savedOrders')
        if(item!=null){
            savedOrders.value = JSON.parse(item).reverse()
        }
    } 
    onMounted(()=>{
        fetchHistory()
    })
    watch(order,()=>{
        setTimeout(()=>{
        window.print()

        },500)
    })


return (_ctx: any,_cache: any) => {
  return (!_unref(order))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, "Table " + _toDisplayString(_unref(order).table), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(order).timestamp), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(order).saveOrders, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                  (item.cold!=undefined && item.cold)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "(冷)"))
                    : (item.cold!=undefined && !item.cold)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "(热)"))
                      : _createCommentVNode("", true),
                  (item.bigPrice!=undefined && !item.bigPrice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "(小)"))
                    : (item.bigPrice!=undefined && item.bigPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, "(大)"))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, "x" + _toDisplayString(item.qty), 1)
                ]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(Math.round(item.total*100)/100), 1)
              ]),
              _hoisted_16
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(Math.round(_unref(order).total*100)/100), 1)
            ])
          ])
        ]),
        _hoisted_21,
        (!_unref(order))
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, "No records found."))
          : _createCommentVNode("", true)
      ]))
}
}

})